export enum ModulosUrlEnum {
  COMPRAS = '/compras',
  ALMOXARIFADO = '/almoxarifado',
  CONTROLE_INTERNO = '/controle-interno',
  FROTAS = '/frotas',
  OBRAS = '/obras',
  PATRIMONIO = '/patrimonio',
  PROTOCOLO = '/protocolo'
}

export const isCurrentModulo = (modulo: ModulosUrlEnum) => {
  const href = window.location.href;

  return href.includes(modulo);
};
